import { render, staticRenderFns } from "./DpaFileViewGlobal.vue?vue&type=template&id=226b7095&"
import script from "./DpaFileViewGlobal.vue?vue&type=script&lang=js&"
export * from "./DpaFileViewGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports